import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthState } from "features/types";
import authServices from "services/auth.services";
import { loginParams } from "services/types";
import { authKey, getStoredAuth, setStoredAuth } from "utils/storageUtils";

const initialState: AuthState = {
  username: undefined,
  id: undefined,
  loading: false,
};

export const login = createAsyncThunk(
  "auth/login",
  async (loginParams: loginParams, { dispatch }) => {
    const response = await authServices.login(loginParams);
    dispatch(loginSucceed(response));
  },
);

export const tryLocalSignIn = createAsyncThunk(
  "auth/tryLocalSignIn",
  async (_, { dispatch }) => {
    try {
      const storedAuth = getStoredAuth();
      if (storedAuth !== null) {
        dispatch(
          loginSucceed({
            username: storedAuth.username,
            id: Number(storedAuth.id),
          }),
        );
      }
    } catch (e) {
      console.error(JSON.stringify(e));
    }
  },
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSucceed: (
      state,
      action: PayloadAction<{
        username: string;
        id: number;
      }>,
    ) => {
      const { username, id } = action.payload;
      setStoredAuth({ username, id });
      state.username = username;
      state.id = id;
    },
    setAuthMethod: (state, action: PayloadAction<string>) => {
      state.authMethod = action.payload;
    },
    logout: (state) => {
      localStorage.removeItem(authKey);
      state.id = undefined;
      state.loading = false;
      state.username = undefined;
      state.authMethod = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
      })
      .addCase(login.rejected, (state) => {
        state.loading = false;
      })
      .addCase(login.fulfilled, (state) => {
        state.loading = false;
      });
  },
});

export const { logout, loginSucceed, setAuthMethod } = authSlice.actions;

export default authSlice.reducer;
